export { default } from './ProductCardImage';
